import React, { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Player } from "@lottiefiles/react-lottie-player";
import Lottie from "react-lottie-player";
import frogSlide from "./frog float.json";
import { Link } from "react-router-dom";

const Hero = () => {
  const lottieRef = useRef();
  const [segmentPlayed, setSegmentPlayed] = useState(false);
  const [runGrog, setRunGrog] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 2000,
      offset: 200,
      once: true,
    });
  }, []);

  useEffect(() => {
    const animatedContent = document.getElementById("content-animation");
    if (animatedContent) {
      animatedContent.addEventListener("animationstart", () => {
        setRunGrog(true);
      });
    }

    const leftCloud = document.getElementById("left-cloud");
    const rightCloud = document.getElementById("right-cloud");

    if (leftCloud) {
      leftCloud.addEventListener("animationend", () => {
        leftCloud.classList.replace("slide-fade-left", "updown");
      });
    }
    if (rightCloud) {
      rightCloud.addEventListener("animationend", () => {
        rightCloud.classList.replace("slide-fade-right", "updown");
      });
    }
  }, []);

  return (
    <div className="hero pt-5">
      <div className="row pt-5 justify-content-center gap-3">
        <div>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              zIndex: "9",
            }}
            className="w-100"
          >
            <div>
              <div id="content-animation" className="content">
                <h3 className="mb-4">Welcome to Nimbus</h3>
                <h1 className="mb-2">Smart, Decentralized</h1>
                <h1 className="mb-2" style={{ color: "#FFCF1E" }}>
                  intelligent messaging
                </h1>
                <div className="d-flex align-items-center justify-content-center buttons mt-4 gap-3">
                  <Link to={"/register"}>
                    <button className="bg-btn">
                      Join Beta{" "}
                      <img
                        src="/assets/images/rightarrow.svg"
                        alt="rightarrow"
                      />
                    </button>
                  </Link>
                  <button className="bg-white-btn px-5">Documents</button>
                </div>
              </div>
              <div className="robot zerotofiftyfade">
                <Lottie
                  play
                  loop
                  animationData={frogSlide}
                  style={{ width: "500px", height: "500px" }}
                />
              </div>
            </div>
          </div>
          <div>
            <img
              id="left-cloud"
              className="left-cloud slide-fade-left"
              src="/assets/images/left-cloud.png"
              alt="left-cloud"
            />
          </div>
          <div>
            <img
              id="right-cloud"
              className="right-cloud slide-fade-right"
              src="/assets/images/right-cloud.png"
              alt="right-cloud"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
